import { FiltersService } from './../../services/filters.service';
import { FilterCountChanges, FilterGroup, FiltersState } from './../../../../globals/store/filters.data';
import { Subject } from 'rxjs';
import { Component, Input, OnInit, OnDestroy, ViewChild, OnChanges } from '@angular/core';
import { FiltersGroupingUI, FilterUI, FilterUIType, FiltersGroupUI } from '../../../../globals/store/filters-ui.models';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { take, debounceTime, takeUntil } from 'rxjs/operators';
import { WorkforceGroup } from 'src/app/store/events.era';
import { Wrapper } from '../wrapper.component';
import { FLAGGED_ASSETS, FLAGGED_TASKS, MY_CREATED_ASSETS, MY_CREATED_TASKS, MY_EVENTS, MY_RESPONSIBLE_TASKS } from 'globals/helpers/constants';
import { filterActions } from 'src/app/store/filters.era';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { LabelToggleBar } from '../label-marker/label-toggle-bar';
import { IconComponent } from '../icon/icon.component';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';
import { PhotoToggleCardComponent } from './photo-toggle-card.component';
import { ToggleButtonWrapperComponent } from '../buttons/toggle-button-wrapper.component';
import { FilterListByTruthyProp } from 'src/app/services/pipes/filterListByBooleanProp.pipe';
import { workforceFeature } from 'src/app/store/workforce.era';
import { AssetCardComponent } from '../cards/asset-card.component';

@Component({
    selector: 'filters-bar',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0px', padding: 0, margin: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')]),
            transition('undefined => *', [animate('0ms')]),
        ]),
        trigger('dropMenu', [
            state('expand', style({ height: '*', padding: 0, opacity: 1 })),
            state('collapse, undefined, void', style({ height: '0px', padding: 0, margin: 0, opacity: 0 })),
            transition('* => *', [animate('300ms')]),
        ]),
        trigger('dropBar', [
            state('expand', style({ height: '35px', padding: 0, opacity: 1 })),
            state('collapse, undefined, void', style({ height: '0px', padding: 0, margin: 0, opacity: 0 })),
            transition('* => *', [animate('300ms')]),
        ]),
    ],
    templateUrl: './filters-bar.html',
    styleUrls: ['./filters-bar.scss'],
    imports: [MatCheckboxModule, AssetCardComponent, FilterListByTruthyProp, ToggleButtonWrapperComponent, PhotoToggleCardComponent, CommonModule, PhotoComponent, IconComponent, MatInputModule, MatButtonToggleModule, LabelToggleBar],
    standalone: true
})

export class FiltersBarComponent extends Wrapper<FiltersBarComponent> implements OnInit, OnDestroy, OnChanges {
  expandedStates = {}
  fUITypes = FilterUIType
  @Input() place
  @Input() filterPage: string
  @Input() closeFunction: Function
  @Input() filterGroupings: FiltersGroupingUI[] = []
  nestedHolderStates = {}
  searchAction$: Subject<string> = new Subject<string>();
  workforceGroupsById: { [id:string]: WorkforceGroup } = {}
  @ViewChild('searchInput') searchInput;

  ngOnInit() {
    this.subProp(this.store.select(workforceFeature.selectWorkforceGroupsById), 'workforceGroupsById')
    this.subObservableWithDebounce(this.searchAction$, 333, this.search.bind(this))
    this.initClosedStates()
  }

  ngOnChanges() {
    this.initClosedStates()
  }

  initClosedStates() {
    if(!this.filterGroupings) return;
    this.filterGroupings.forEach(g => {
      if (!this.expandedStates[g.title]) this.expandedStates[g.title] = g.defaultClosed ? 'collapse' : 'expand'
    })
  }

  search(searchTerm: string) {
    const lowerCaseSearchTerm = searchTerm.toLocaleLowerCase()
    this.filterGroupings.forEach(grouping =>
      grouping.filterGroups.forEach(({ filters }) => {
        filters.forEach(filter => {
          switch (grouping.title) {
            case "Groups":
              filter.hidden = !this.workforceGroupsById[filter.id].realName.toLocaleLowerCase().includes(lowerCaseSearchTerm)
              break
            case "People":
              filter.hidden = !filter.searchTerm.includes(lowerCaseSearchTerm)
              break
            case "Workforce Contact": 
              console.log({ filter, filters, grouping })
              filter.hidden = !filter.searchTerm.includes(lowerCaseSearchTerm)
              break
            case "Performers":
              filter.hidden = !filter.name.toLocaleLowerCase().includes(lowerCaseSearchTerm)
              break
            default:
              break
          }
        })
      }))

  }

  ngOnDestroy() {
    // console.log('Filters bar being destroyed...')
    this.resetTempFilterCount()
  }

  resetTempFilterCount() {
    this.store.select('filters').pipe(take(1)).subscribe((filtersState: FiltersState) => {
      if (filtersState[this.filterPage].count !== filtersState.tempCounts[this.filterPage]) {
        console.log('Temp count and real filter count out of sync, SetTempFilterCountToRealFilterCount being called', filtersState)
        this.store.dispatch(filterActions.setTempFiltersCountToRealFiltersCount(this.filterPage))
      }
    })
  }

  trackByIndex(index) {
    return index
  }

  trackByGrouping(index, grouping: FiltersGroupingUI) {
    return index
  }

  trackByGroup(index, group: FiltersGroupUI) {
    return index
  }

  trackByFilter(index, filter: FilterUI) {
    return index
  }

  toggleNestedFilter(event, filter: FilterUI) {
    event.stopPropagation();
    if (filter.disabled && !filter.selected) return // disallow selecting of disabled filters
    this.nestedHolderStates[filter.id] = this.nestedHolderStates[filter.id] === 'expand' ? 'collapse' : 'expand'
  }

  resetFilterAndChildren(filter: FilterUI) {
    filter.selected = false
    if (filter.children) filter.children.forEach(this.resetFilterAndChildren.bind(this))
  }

  resetFiltersUI() {
    this.filterGroupings.forEach(g => g.filterGroups.forEach(fg => fg.filters.forEach(this.resetFilterAndChildren.bind(this))))
  }

  resetSoloSelection() { // so this is here because if you have a solo selection selected and select a filter that is NOT a solo selection, then you have to undo the solo selection for things to work the way they are supposed to.  This resets the solo selection (to unselected) and returns true if it found one

    let found = false
    this.filterGroupings.forEach(g => g.filterGroups.forEach(fg => fg.filters.forEach(f => {
      if (f.soloSelection && f.selected) {
        f.selected = false
        found = true
      }
      if (f.children) f.children.forEach(f => { // one level of children here, should be enough
        if (f.soloSelection && f.selected) {
          f.selected = false
          found = true
        }
      })
    })))
    return found
  }

  toggleFilter(filter: FilterUI) {
    const cannotToggle = filter.disabled && !filter.selected
    // console.log({ filter: jsonCopyObject(filter), cannotToggle })
    if (cannotToggle) return // disallow selecting of disabled filters

    if (filter.soloSelection) {
      const selected = !filter.selected
      this.resetFiltersUI()
      filter.selected = selected
      this.store.dispatch(filterActions.changeFilterCount({
        filterGroup: this.filterPage, changeType: FilterCountChanges.Set, value: selected ? 1 : 0
      }))
      if (!selected) {
        this.store.dispatch(filterActions.updateFilters({ filterGroup: this.filterPage, filters: { count: 0 }}))
      } else {
        if (this.filterPage === this.filterPageTypes.home) {
          this.filterPage === this.filterPageTypes.home && this.applyFilter()
        } else {
          this.filtersService.disableEnableFilters(this.filterPage, this.extractFiltersFromUI())
        }
      }
      return // always return from soloSelection
    }

    if (filter.selected) {
      this.store.dispatch(filterActions.changeFilterCount({
        filterGroup: this.filterPage, changeType: FilterCountChanges.Decrement
      }))
      filter.selected = false
    } else {
      this.store.dispatch(filterActions.changeFilterCount({
        filterGroup: this.filterPage, changeType: FilterCountChanges.Increment
      }))
      filter.selected = true
      const foundSoloSelection = this.resetSoloSelection()
      if (foundSoloSelection) this.store.dispatch(filterActions.changeFilterCount({
        filterGroup: this.filterPage, changeType: FilterCountChanges.Decrement
      }))
    }
    if (this.filterPage === this.filterPageTypes.home) {
      this.filterPage === this.filterPageTypes.home && this.applyFilter()
    } else {
      this.filtersService.disableEnableFilters(this.filterPage, this.extractFiltersFromUI())
    }
  }

  clearFilter() {
    this.filterGroupings.forEach(grouping =>
      grouping.filterGroups.forEach(group =>
        group.filters.forEach(filter => {
          filter.selected = false
          filter.children && filter.children.forEach(childFilter => childFilter.selected = false)
        }))) // for UI only
    this.store.dispatch(filterActions.changeFilterCount({
      filterGroup: this.filterPage,
      changeType: FilterCountChanges.Reset
    }))
    this.filtersService.disableEnableFilters(this.filterPage, this.extractFiltersFromUI())
  }

  extractFiltersFromUI(): FilterGroup {
    const newFilters: FilterGroup = { count: 0 }
    // console.log(" extractFiltersFromUI called", this.filterGroupings)
    this.filterGroupings.forEach(grouping =>
      grouping.filterGroups.forEach(({ groupId, filters }) => {
        filters.forEach(({ id, selected, name, innerGroupId, children }) => {
          if (children) {
            children.filter(c => c.selected).forEach(({ id, innerGroupId: groupId, name }) => {
              if (!newFilters[groupId]) {
                newFilters[groupId] = []
              }
              newFilters.count++
              newFilters[groupId].push(id)
            })
          }
          if (selected) {
            groupId = innerGroupId ? innerGroupId : groupId // sometimes a filter is of a different type than its grouping's type
            if (groupId === 'Meta') {
              switch (name) {
                case MY_CREATED_TASKS:
                case MY_CREATED_ASSETS:
                  newFilters.me = true
                  newFilters.count++
                  break
                case MY_RESPONSIBLE_TASKS:
                case MY_RESPONSIBLE_TASKS:
                  newFilters.myResponsibility = true
                  newFilters.count++
                  break
                case FLAGGED_TASKS:
                case FLAGGED_ASSETS:
                  newFilters.flagged = id
                  newFilters.count++
                  break
                case MY_EVENTS:
                  newFilters.myEvents = true
                  newFilters.count++
                  break
                default:
                  console.log('Meta filter that didn\'t hit a switch case!', name)
                  break
              }
              return // special case handling for "me" and "flagged", since they are single value holders and not lists
            }
            if (!newFilters[groupId]) {
              newFilters[groupId] = []
            }
            newFilters.count++
            newFilters[groupId].push(id)
          }
        })
      }))
    return newFilters
  }

  applyFilter() {
    this.store.dispatch(filterActions.updateFilters({ filterGroup: this.filterPage, filters: this.extractFiltersFromUI() }))
  }

}
